import { render, staticRenderFns } from "./DetailGroupDialog.vue?vue&type=template&id=17f7bb78"
import script from "./DetailGroupDialog.vue?vue&type=script&lang=js"
export * from "./DetailGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailGroupDialog.vue?vue&type=style&index=0&id=17f7bb78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports